import * as React from 'react';
import { useState, useCallback, Children, cloneElement } from 'react';
import { GroupContainer } from './styles.js';

const RadioBoxGroup = ({ testId , name , children , defaultValue ="" , onChange , className  })=>{
    const [checkedValue, setCheckedValue] = useState(defaultValue);
    const changeHandler = useCallback((event)=>{
        const { value  } = event.target;
        if (typeof onChange === "function") {
            onChange(event);
        }
        setCheckedValue(value);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ React.createElement(GroupContainer, {
        "data-testid": testId,
        className: className
    }, Children.map(children, (radioButton)=>/*#__PURE__*/ cloneElement(radioButton, {
            name,
            isChecked: radioButton.props.value === checkedValue,
            onChange: changeHandler
        })));
};

export { RadioBoxGroup };
